import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { ClienteFincaLoteResponse } from "../../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { LoteInfoAgriculturaRender } from "./LoteInfoAgriculturaRender";
import { LoteInfoGanaderiaRender } from "./LoteInfoGanaderiaRender";
import { LoteInfoRender } from "./LoteInfoRender";

/** Crea el `LoteInfoRender` acorde al tipo de la finca activa: ganadería si la
 *  finca es ganadera, agricultura en el resto de los casos. */
export function createLoteInfoRender(
  lote: ClienteFincaLoteResponse,
): LoteInfoRender {
  const finca = serviceProvider.getFincaSelectedService().getRequired();
  if (finca.isGanaderia) return new LoteInfoGanaderiaRender(lote);
  return new LoteInfoAgriculturaRender(lote);
}
